import { Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Component({
  selector: 'app-sucu05-button0020005',
  templateUrl: './sucu05-button0020005.component.html',
})
export class Sucu05Button0020005Component implements OnInit {

    constructor(
        private http: _HttpClient
    ) { }

    ngOnInit() {
    }

}
